module.exports = __webpack_public_path__ + "media/img/favicon-2ad27d65e4aaa6d4ec1241d2688255e2.png";